import { makeStyles } from "@mui/styles";
import Theme from "../../themes/theme";

export default makeStyles((theme: Theme) => ({
  campaignDateTimeContainer: {
    margin: "-8px !important",
    position: "absolute",
    top: "0",
    tabindex: -1,
    opacity: 0,
  },
  datepicker: {
    width: "100%",
    margin: "8px 8px 8px 0px",
    borderColor: theme.palette.UI.black,
  },
  Datepickerlabel: {
    color: theme.palette.UI.blue_80,
    fontSize: "11px !important",
    lineHeight: "23px",
    marginLeft: 16,
    marginBottom: 0,
  },
  errorLabel: {
    color: `${theme.palette.UI.red} !important`,
  },
  numericInput: {
    padding: 10,
    "&::-webkit-inner-spin-button": {
      opacity: 1,
    },
  },
  numericInputFormControl: {
    position: "relative",
    width: "70px",
    height: "40px",
  },
  timePickerContainer: {
    width: "100%",
    order: 2,
    padding: 10,
    display: "flex",
    justifyContent: "space-evenly",
  },
  arrowWrapper: {
    display: "flex",
    flexDirection: "column",
    position: "absolute",
    top: -21,
    right: -5,
  },
  arrow: {
    marginBottom: "-4px",
    cursor: "pointer",
    "&:active": {
      "& path": {
        fill: `${theme.palette.UI.purple}!important`,
      },
    },
  },
  monthChangeIcons: {
    position: "absolute",
    overflow: "visible",
    cursor: "pointer",
    fontSize: 16,
    fontWeight: 600,
  },
  nextMonthArrow: {
    top: 4,
    right: 27,
  },
  prevMonthArrow: {
    left: 20,
    top: 4,
  },
  timeRangeContainer: {
    width: "fit-content",
  },
  timeRangeDivider: {
    [theme.breakpoints.up("sm")]: {
      width: 1,
      background: "#EBEBEB",
    },
  },
  dateTimeText: {
    maxHeight: "33px",
    "& .MuiPickersSectionList-root": {
      padding: "8px 0px",
    },
    "& fieldset": {
      borderColor: "#828282",
    },
    "& p.MuiFormHelperText-root.Mui-error": {},
  },
  errorSpan: {
    color: "#E61717",
    fontSize: 10,
    marginTop: 2,
    marginLeft: 5,
  },
  root: {
    top: "140px !important",
  },
}));
